import React from 'react'
import EndorsementButton from '../../public/Company/Profile/components/Endorsement/EndorsementButton';
import { EndorsementsBadge } from '../../public/Company/Profile/components/Endorsement/EndorsementsBadge';

// TIP-492/504 — viewing endorsements is member-gated on the VIEWER's active
// company. The banner shows the real count to a member and the membership
// prompt to a non-member (both via EndorsementsBadge), plus the "give" button
// for non-owner viewers. `viewerIsMember` / `endorsementCount` come from the
// member-gated view endpoint, fetched by the container (BannerCompanyCard).
export const ENDORSEMENT_MEMBER_PROMPT = "Become a member to view endorsements.";

function EndorsementBanner({
  company,
  role,
  companyType,
  userInfo,
  trevexId,
  endorsementMode = null,
  endorsementCount = 0,
}) {
  const showGiveButton = (companyType === "claimed" || companyType === "verified") && !role;

  // Nothing to surface: no endorsement element (target not a member / none) and
  if (!endorsementMode && !showGiveButton) return null;

  return (
    <div>
      <div className="bg-[#002940] w-full text-slate font-semibold p-2 rounded-b-lg">
        <div className='flex justify-between items-center m-auto md:px-[1rem] lg:px-[1.75rem]'>
          <div className='flex w-auto sm:w-[50%] gap-3 items-center'>
            <EndorsementsBadge mode={endorsementMode} count={endorsementCount} />
          </div>
          {showGiveButton && (
            <EndorsementButton userInfo={userInfo} company={company} trevexId={trevexId} />
          )}
        </div>
      </div>
    </div>
  )
}

export default EndorsementBanner
